
import {
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import {
  provideHttpClient,
  withFetch,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppModule } from './app.module';

// Datadog's APP_INITIALIZER lives in main.ts's browser-only config, not
// here — this appConfig is merged into SSR by app.config.server.ts, and
// importing DatadogRumService/@datadog/browser-rum here would pull the
// browser-only SDK into the server bundle even though init() itself would
// no-op server-side (Copilot review, USONESHOP-3946).
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    importProvidersFrom(AppModule),
  ],
};
